
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { useFocusGesture } from '../../gestures/use-focus-gesture.mjs.js';
import { useHoverGesture } from '../../gestures/use-hover-gesture.mjs.js';
import { useTapGesture } from '../../gestures/use-tap-gesture.mjs.js';
import { useViewport } from './viewport/use-viewport.mjs.js';
import { makeRenderlessComponent } from '../utils/make-renderless-component.mjs.js';

var gestureAnimations = {
    inView: makeRenderlessComponent(useViewport),
    tap: makeRenderlessComponent(useTapGesture),
    focus: makeRenderlessComponent(useFocusGesture),
    hover: makeRenderlessComponent(useHoverGesture),
};

export { gestureAnimations };
//# sourceMappingURL=gestures.mjs.js.map
